import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { BuildingLeftMenuList } from "../utils/constants";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const Building_Faqs = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2"></div>
          </div>
        </div>
      </section>

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title">
                    <h3 className="fontSizeClass">
                      {t("Dept.of Building :: FAQs")}
                    </h3>
                  </div>
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="heading1">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse1"
                          aria-expanded="true"
                          aria-controls="collapse1"
                        >
                          1.
                          {t("What are the key activities of the Department")}?
                        </button>
                      </div>
                      <div
                        id="collapse1"
                        className="collapse show"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          {t("The key activities of the department are")}:
                          <ol className="kmc-function-list ml-2" type="a">
                            {[
                              "To extend sanction for erection of new building",
                              "To extend sanction to for extension/ remodeling/renovation of existing building",
                              "To stop unauthorised construction",
                              "To demolish unauthorised construction",
                              "To consider the constructions done without proper permission.",
                              "To keep vigilance against any of heritage building",
                              "Delivery of certified copy of plans.",
                              "To take reasonable action against insecure buildings.",
                              "To application submitted under RTI Act under guide line.",
                            ].map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ol>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading2">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse2"
                          aria-expanded="true"
                          aria-controls="collapse2"
                        >
                          2.
                          {t(
                            "What activities do not require any permission from KMC’s building department"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse2"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <a
                            href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"a3efc1a3-7587-4638-a000-7b9065655345"}&tenantId=km.kolkata`}
                          >
                            {t(
                              "Please consult Rule 3(2) of KMC Building Rule 2009"
                            )}
                            .
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading3">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse3"
                          aria-expanded="true"
                          aria-controls="collapse3"
                        >
                          3.
                          {t(
                            "Do I need to take approval from KMC to demolish my building"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse3"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "No permission is required in case of non-heritage buildings. However, a notice is to be given to the municipal commissioner in this regard. You should also ensure that the demolition work is carried out under the supervision of an empanelled Structural Engineer. But, in case of a heritage building permission from heritage conservation committee is required"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading4">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse4"
                          aria-expanded="true"
                          aria-controls="collapse4"
                        >
                          4.
                          {t(
                            "What activities require permission from KMC's building department"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse4"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "Work that requires permission from KMC's building department includes the following"
                            )}
                            ,<br />
                            a. {t("Erection of a new building")}
                            <br />
                            b.
                            {t(
                              "Addition or alteration of an existing building"
                            )}
                            <br />
                            c.
                            {t(
                              "Re-erection of any building where the structure has been pulled down, burnt or destroyed"
                            )}
                            .<br />
                            d. {t("Change of use of an existing building")}
                            <br />
                            e. {t("Reconstruction of an existing roof")}
                            <br />
                            f. {t("Any structural change")}
                            <br />
                            g.
                            {t(
                              "Removal or reconstruction of principal staircase or alteration of its position"
                            )}
                            <br />
                            h. {t("Installation of a new lift")}
                            <br />
                            i.
                            {t(
                              "Permanent closure of any door or window in any external window"
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading5">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse5"
                          aria-expanded="true"
                          aria-controls="collapse5"
                        >
                          5.
                          {t(
                            "What consequences would I face if I undertake any of the above construction activities without obtaining sanction"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse5"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "KMC is very serious about ensuring that each building in its jurisdiction is constructed with appropriate authorization. In case of unauthorized construction, KMC may lodge a complaint with the police who would in turn issue an arrest warrant. KMC may also decide to demolish the building without granting any opportunity for hearing"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading6">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse6"
                          aria-expanded="true"
                          aria-controls="collapse6"
                        >
                          6.
                          {t(
                            "What application form do I need to fill up, what documents do I need to submit for getting permission from the Building Department"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse6"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <Link
                            className="nav-link fontSizeClass"
                            to="/Building_Sanction_Download_Forms"
                            target="_blank"
                          >
                            {t("Click Here")}.
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading7">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse7"
                          aria-expanded="true"
                          aria-controls="collapse7"
                        >
                          7.
                          {t(
                            "Can I construct any building with asbestos sheet or similar material without sanction"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse7"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          {t(
                            "No, such construction is not allowed without approval from KMC"
                          )}
                          .
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading8">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse8"
                          aria-expanded="true"
                          aria-controls="collapse8"
                        >
                          8.
                          {t(
                            "Is there any stipulation regarding building materials that can be used"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse8"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "There are no specific stipulations but the materials should be as per the NBC"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading9">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse9"
                          aria-expanded="true"
                          aria-controls="collapse9"
                        >
                          9.
                          {t(
                            "What are the basic parameters used for calculation of sanction fees in case of building plan"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse9"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <DownloadFileByFileStoreId
                            fileStoreId={"879a4e97-73a3-4943-a963-ed288d49d6c5"}
                            label={"Click Here"}
                            classAdd={false}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse10"
                          aria-expanded="true"
                          aria-controls="collapse10"
                        >
                          10.
                          {t(
                            "What departments/Institutions do I need to get an NOC issued from? Why is such an NOC required"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse10"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t("Please consult")}{" "}
                            <DownloadFileByFileStoreId
                              fileStoreId={
                                "740c9d3b-4ea7-46f7-a7f6-12b7f8160af1"
                              }
                              label={"Rule 4 of KMC Building Rule 2009"}
                              classAdd={false}
                            />{" "}
                            {t(
                              "Other information may be obtained from License Building surveyor"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse11"
                          aria-expanded="true"
                          aria-controls="collapse11"
                        >
                          11.
                          {t(
                            "Under what cases the observation of the Municipal Building Committee (MBC) is required prior to sanction"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse11"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t("Please consult")}{" "}
                            <DownloadFileByFileStoreId
                              fileStoreId={
                                "f31c48d2-db17-4180-8f90-949223486c02"
                              }
                              label={"Rule 38 of KMC Building Rule 2009"}
                              classAdd={false}
                            />
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse12"
                          aria-expanded="true"
                          aria-controls="collapse12"
                        >
                          12.
                          {t(
                            "To undertake construction work or repair work, I need to stack up the building material on the footpath. Do I need to take permission? If yes, then from whom"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse12"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          {t(
                            "You need to take permission from the conservancy department of KMC. You can contact either the ward office or the borough office"
                          )}
                          .
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading13">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse13"
                          aria-expanded="true"
                          aria-controls="collapse13"
                        >
                          13.
                          {t(
                            "I need to erect scaffolding on footpath or road. Do I need to take permission"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse13"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "You need to take permission from the conservancy department of KMC. You can contact either the ward office or the borough office"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading14">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse14"
                          aria-expanded="true"
                          aria-controls="collapse14"
                        >
                          14.
                          {t(
                            "To undertake construction work or repair work, I need water for plastering, flooring and other repair/civil work. Do I need to take permission from KMC for use of water"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse14"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          {t(
                            "Yes, you need to take permission from the water supply department of KMC. You would be required to pay prescribed charges for the same"
                          )}
                          .
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading15">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse15"
                          aria-expanded="true"
                          aria-controls="collapse15"
                        >
                          15.
                          {t(
                            "After issuance of building sanction plan for how long can commencement / completion of construction work wait"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse15"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          {t(
                            "You need to start the construction of your building within 2 years of sanctioning of building plan. The construction of building should be completed within 5 years from the date of sanction of building plan"
                          )}
                          .
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading16">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse16"
                          aria-expanded="true"
                          aria-controls="collapse16"
                        >
                          16.
                          {t(
                            "If I have exceeded the time frame for completion how can I extend the validity period"
                          )}
                          ?
                        </button>
                      </div>
                      <div
                        id="collapse16"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "In order to apply for such extension, you need to submit the following documents"
                            )}
                            :<br />
                            a.
                            {t(
                              "Application letter giving reasons for seeking such extension"
                            )}
                            <br />
                            b. {t("Consolidated rate bill (Current)")}
                            <br />
                            c.
                            {t(
                              "Letter from concerned LBS/Architect and ESE, certifying that the construction already done is in conformity with the Building Permit. The objective is to ensure structural stability"
                            )}
                            <br />
                            d. {t("Letter of Commencement")}
                            <br />
                            e. {t("Copy of the Sanctioned building plan")}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading17">
                        <button
                          className="btn btn-link fontSizeClass  m-2"
                          data-toggle="collapse"
                          data-target="#collapse17"
                          aria-expanded="true"
                          aria-controls="collapse17">
                          17. {t( "Do I need to submit any documents to KMC after the completion of construction")} ?
                        </button>
                      </div>
                      <div id="collapse17" className="collapse" data-parent="#accordion">
                        <div className="card-body m-3 fontSizeClass ">
                          <p className="fontSizeClass d-flex">
                            <span className="mr-1">{t("Please consult")}</span>
                            <DownloadFileByFileStoreId
                              fileStoreId={"53a61866-04e0-4254-afc4-04b0898dd7b8"}
                              label={"Rule 27 of KMC Building Rule 2009"}
                              classAdd={false} />               
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading18">
                        <button className="btn btn-link fontSizeClass  m-2" data-toggle="collapse" data-target="#collapse18" aria-expanded="true" aria-controls="collapse18">
                          18.
                          {t( "If there is a building around in dilapidated condition what action can I take as a citizen" )}
                          ?
                        </button>
                      </div>
                      <div id="collapse18" className="collapse" data-parent="#accordion">
                        <div className="card-body m-3 fontSizeClass">
                          <p className="fontSizeClass">
                            {t(
                              "KMC encourages responsible citizens to provide information regarding dilapidated buildings. Kindly inform DG (Building) or Deputy Chief Engineer or Borough Executive Engineer (Building)"
                            )}
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Building_Faqs;
